import React from "react";

import { useTranslation } from "react-i18next";

interface BoardEditActionsProps {
    onCancel: () => void;
    onSave: () => void;
    isExiting: boolean;
}

export const BoardEditActions: React.FC<BoardEditActionsProps> = ({
    onCancel,
    onSave,
    isExiting,
}) => {
    // 44px (h-11) as requested
    const { t } = useTranslation("common");
    const sizeClass = "w-10 h-10";

    return (
        <div className={`flex items-center gap-2 z-30 transition-all duration-200 ease-in-out ${isExiting ? 'opacity-0 scale-90' : 'animate-fade-in opacity-100 scale-100'}`}>
            {/* Cancel Button */}
            <button
                onClick={onCancel}
                className={`${sizeClass} flex items-center justify-center rounded-full shadow-md bg-white text-red-400 hover:bg-accent-primary hover:text-white transition-all duration-200 ease-out border border-neutral-200`}
                title={t("actions.cancel") || "Cancel changes"}
            >
                <span className="w-5 h-5" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_36f64f9f.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_36f64f9f.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
            </button>

            {/* Validate Button */}
            <button
                onClick={onSave}
                className={`${sizeClass} flex items-center justify-center rounded-full shadow-md bg-white text-emerald-500 hover:bg-accent-primary hover:text-white transition-all duration-200 ease-out border border-neutral-200`}
                title={t("actions.save") || "Save changes"}
            >
                <span className="w-5 h-5" style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_247c0df2.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_247c0df2.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
            </button>
        </div>
    );
};
